import { Image } from 'antd';
import { useState, useRef, forwardRef, useImperativeHandle } from 'react';

const getImgListener = (namespace, setImgPreview: (ev: MouseEvent) => void) => {
  const domList = [];
  const images = document
    ?.querySelector(`#${namespace}`)
    .getElementsByTagName('img');
  for (let i = 0; i < images.length; i++) {
    images[i].addEventListener('click', setImgPreview);
    domList.push(images[i]);
  }
  return () => {
    domList.forEach((dom) => {
      dom.removeEventListener('click', setImgPreview);
    });
  };
};

export interface ImageRef {
  register: (namespace: string) => () => void;
}

type ImageViewerProps = {
  container: HTMLElement;
};

const ImageViewer: React.ForwardRefExoticComponent<
  React.RefAttributes<ImageRef> & ImageViewerProps
> = forwardRef(({ container }, ref) => {
  const [imgSrc, setImgSrc] = useState('');
  const [visible, setVisible] = useState(false);
  const setImgPreview = (e) => {
    const src = e.target.getAttribute('src');
    setImgSrc(src);
    setVisible(true);
    document.body.style.overflow = 'hidden';
  };

  useImperativeHandle(
    ref,
    () => {
      return {
        register: (namespace: string) => {
          return getImgListener(namespace, setImgPreview);
        },
      };
    },
    []
  );
  return (
    <Image
      style={{ display: 'none' }}
      src={imgSrc}
      alt={''}
      preview={{
        visible: visible,
        src: imgSrc,
        onVisibleChange: (value) => {
          setVisible(value);
          document.body.style.overflow = 'auto';
        },
        getContainer: () => container,
      }}
    />
  );
});

ImageViewer.displayName = 'ImageViewer';

export default ImageViewer;
